import httpClient from "./httpClient.js";
import { IUniformPayment, ICreateUniformPayment, IUpdateUniformPayment } from "../interfaces/IUniformPayment";

export const createUniformPayment = async (data: ICreateUniformPayment): Promise<IUniformPayment> => {
  const response = await httpClient.post('/uniform-payment', data);
  return response.data;
};

export const getUniformPaymentsByPartner = async (partnerId: number): Promise<IUniformPayment[]> => {
  const response = await httpClient.get(`/uniform-payment/partner/${partnerId}`);
  return response.data;
};

export const updateUniformPayment = async (id: number, data: IUpdateUniformPayment): Promise<IUniformPayment> => {
  const response = await httpClient.patch(`/uniform-payment/${id}`, data);
  return response.data;
};

export const deleteUniformPayment = async (id: number): Promise<void> => {
  await httpClient.delete(`/uniform-payment/${id}`);
};

export const getAllUniformPayments = async (): Promise<IUniformPayment[]> => {
  const response = await httpClient.get('/uniform-payment');
  return response.data;
};

export const getUniformPaymentsByApplication = async (applicationId: number): Promise<IUniformPayment[]> => {
  const response = await httpClient.get(`/uniform-payment/application/${applicationId}`);
  return response.data;
};

export const updateUniformPaymentPartnerId = async (applicationId: number, partnerId: number): Promise<IUniformPayment> => {
  const response = await httpClient.patch(`/uniform-payment/update-partner/${applicationId}/${partnerId}`);
  return response.data;
};
